<template>
  <div class="address">
    <div>
      <span v-for="(icon, index) in icons" :data-balloon="$t(icon.label)" data-balloon-pos="up">
        <i :class="icon.classList"></i>
      </span>
    </div>
    <p class="name">{{ nameline }}</p>
    <p>{{ address }}</p>
    <p>{{ cityline }}</p>
    <p>{{ countryName }}</p>
    <p v-if="phone">{{ $t('Common.phone') }} {{ phone }}</p>
    <p v-if="phone2">{{ $t('Common.phone2') }}  {{ phone2 }}</p>
    <section v-if="editable || removable">
      <a class="link link-info" v-if="editable" v-on:click="emitEdit"><i class="fa fa-edit"></i> {{ $t('Action.edit') }}</a>
      <a class="link link-danger float-right" v-if="removable" v-on:click="emitRemove"><i class="fa fa-trash"></i> {{ $t('Action.remove') }}</a>
    </section>
    <section v-if="selectable" class="a-c">
      <button class="btn btn-xs btn-success"v-on:click="emitSelect"><i class="fa fa-check"></i> {{ $t('Action.select') }}</button>
    </section>
    <section v-if="changable" class="a-c">
      <button class="btn btn-xs btn-info"v-on:click="emitChange"><i class="fa fa-exchange-alt"></i> {{ $t('Action.change') }}</button>
    </section>
  </div>
</template>
<script>
import Countries from '../Mixins/Countries.js';

export default {
  props: {
    contactId: {
      type: Number
    },
    type: {
      type: Number
    },
    title: {
      type: String
    },
    firstname: {
      type: String,
      default: ''
    },
    lastname: {
      type: String
    },
    address: {
      type: String
    },
    postalcode: {},
    city: {
      type: String
    },
    country: {
      type: String
    },
    phone: {
      type: String
    },
    phone2: {
      type: String
    },
    isShipping: {
      type: Number,
      default: 0
    },
    isBilling: {
      type: Number,
      default: 0
    },
    isHome: {
      type: Number,
      default: 0
    },
    editable: {
      type: Boolean,
      default: false
    },
    removable: {
      type: Boolean,
      default: false
    },
    selectable: {
      type: Boolean,
      default: false
    },
    changable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    icons() {
      var icons = [],
          icon;

      if (this.isHome == 1) {
        icons.push({
          label: 'Addresses.addressMain',
          classList: 'fa fa-home link-success'
        });
      }

      if (this.isBilling > 0) {
        icon = {
          label: 'Addresses.addressBilling',
          classList: 'fa fa-money-bill-alt'
        };
        if (this.isBilling == 2) {
          icon.label += ' (Standard)';
          icon.classList += ' link-success';
        }
        icons.push(icon);
      }

      if (this.isShipping > 0) {
        icon = {
          label: 'Addresses.addressShipping',
          classList: 'fa fa-truck'
        };
        if (this.isShipping == 2) {
          icon.label += ' (Standard)';
          icon.classList += ' link-success';
        }
        icons.push(icon);
      }

      return icons;
    },
    nameline() {
      if (this.firstname != '') {
        return this.firstname + ' ' + this.lastname;
      }

      return this.lastname;
    },
    cityline() {
      switch (this.country) {
        case 'US':
          return this.city + ', ' + this.postalcode;
          break;
        default:
          return this.postalcode + ' ' + this.city;
      }
    },
    countryName() {
      if (this.country && Countries.hasOwnProperty(this.country))
        return Countries[this.country];
    }
  },
  methods: {
    getContactData() {
      return {
        ID: this.contactId,
        type: this.type,
        title: this.title,
        firstname: this.firstname,
        lastname: this.lastname,
        address: this.address,
        postalcode: this.postalcode,
        city: this.city,
        country: this.country,
        isShipping: this.isShipping,
        isBilling: this.isBilling,
        isHome: this.isHome
      };
    },
    emitRemove() {
      this.$emit('remove', this.contactId);
    },
    emitEdit() {
      this.$emit('edit', this.contactId, this.getContactData());
    },
    emitSelect() {
      this.$emit('select', this.contactId, this.getContactData());
    },
    emitChange() {
      this.$emit('change', this.contactId, this.getContactData());
    }
  }
}
</script>
